import { tokens } from '@cast/design-system';

import {
  CpuHistoricalMetricKey,
  CpuPredictionMetricKey,
  JvmMetricKey,
} from './ResourceChartSections/_constants';
import { OptimizationWorkloadContainerMetricsValues } from '../../_types';

export const jvmMetricToColor: Record<JvmMetricKey, string> = {
  heapCommitted: tokens.theme.data.blue400,
  heapRecommended: tokens.theme.fg.structural.primary,
  heapUsed: tokens.theme.data.green500,
};

export const jvmMetricToTitle: Record<JvmMetricKey, string> = {
  heapCommitted: 'Heap size',
  heapRecommended: 'Heap recommended',
  heapUsed: 'Heap P95 usage',
};

export const percentileToColor: Record<
  OptimizationWorkloadContainerMetricsValues | 'avgStall',
  string
> = {
  req: tokens.theme.data.blue200,
  rec: tokens.theme.fg.structural.primary,
  min: tokens.theme.data.green300,
  p25: tokens.theme.data.green500,
  p50: tokens.theme.data.yellow300,
  p75: tokens.theme.data.yellow700,
  avg: tokens.theme.data.green300,
  max: tokens.theme.data.green700,
  avgStall: tokens.theme.data.red500,
  recPredicted: tokens.theme.data.indigo300,
  avgPredicted: tokens.theme.data.indigo100,
};

export const percentileToTitle: Record<
  OptimizationWorkloadContainerMetricsValues | 'avgStall',
  string
> = {
  req: 'Requested',
  rec: 'Recommended',
  min: 'Min usage',
  p25: 'p25',
  p50: 'p50',
  p75: 'p75',
  avg: 'Avg usage',
  max: 'Max usage',
  avgStall: 'Avg. Cpu Stall',
  recPredicted: 'Predicted Recommended',
  avgPredicted: 'Predicted Avg Usage',
};

export const nonPredictionStrokeDasharrayMap: Partial<
  Record<CpuHistoricalMetricKey, string>
> = { rec: '3 3' };

export const predictionStrokeDasharrayMap: Partial<
  Record<CpuPredictionMetricKey, string>
> = { rec: '3 3' };

export const percentileToDasharray: (
  key: OptimizationWorkloadContainerMetricsValues | 'avgStall',
  isReadOnly: boolean
) => string | undefined = (key, isReadOnly) => {
  switch (key) {
    case 'rec':
      return isReadOnly ? '3 3' : undefined;
  }
  return undefined;
};
